export default "__VITE_ASSET__04528dfe__"